import React, { createRef } from 'react';
import BaseClass from '../common/baseClass';
import { createPortal } from 'react-dom'; // Importa createPortal da react-dom
import { Link } from "react-router-dom";
import $ from 'jquery'; // Importa jQuery

import { connect } from "react-redux";
import { changeDatalist, setNewUrlState, changeValues } from "../../redux/actions";
import { wishListSelector } from "../../redux/selectors";

import { menuHomeOpen } from '../Header/HeadersButtons';
import { doLogout } from './logout';
import LoaderView from './loader';
import '../../css/page-body.css';

const common = require('../common/common');
const env = require("../../config.js").default;

class TooltipCart extends BaseClass {
  constructor(props) {
    super(props);
    this.state = {
      arti: this.props.articolo,
      isHovered: false,
      showLoader: false,
    };
    this.marcheVm = window.cc.enabledVMs;
    this.listVm = Object.keys(window.cc.enabledList);
    this.checkout_data = "";
    this.targetRef = createRef();

    this.updateStateWithStoreProps();
  }

  saveCheckout = (e, wishList) => {
    e.preventDefault();
    if (wishList !== undefined && wishList !== null && wishList.length > 0) {
      this.setState({ showLoader: true });
      common.apiCall(env.BACKEND + 'cart/', 'POST', {}, true)
        .then((cart) => {
          if (cart === undefined || cart.id === undefined)
            return false;
          this.checkout_data = common.get_localStorage("checkout_url") + '?cart_id=' + cart.id;
          var data = { items: [] };
          for (var i = 0; i < wishList.length; i++) {
            data['items'].push({ "brand": wishList[i].marca, "part_number": wishList[i].carti, "description": wishList[i].darti, "quantity": wishList[i].qpezzi, "currency": wishList[i].cvalu, "price": wishList[i].price });
          }

          common.apiCall(env.BACKEND + 'cart/' + cart.id + '/', 'PATCH', data, true)
            .then(() => {
              this.removeAllArticoli(e);
              doLogout();
              let checkout_in_frame = common.get_localStorage("checkout_in_frame");
              if(common.inIframe() && !(checkout_in_frame !== undefined && checkout_in_frame !== null && checkout_in_frame)){
                window.top.location.href = this.checkout_data;
              } else {
                window.location.href = this.checkout_data;
              }
            });
        });
    }
  }

  gotoCart = () => {
    $('.tooltip_cart').fadeOut();
    menuHomeOpen();
  }

  async gotoTavola(marca, modello, tavola, carti) {
    const $ = window.$;
    $(".tooltip_cart").hide();
    menuHomeOpen(false);
    window.$(".banner_center_header>a").click();
    var params = {
      marca: marca,
      modello: modello,
      tavola: tavola,
      carti: carti,
    }

    var detailDistinta = await common.apiCall(env.BACKEND + "epc/get_draw/", "GET", { zprod: marca, cmoto: modello, ctavo: tavola }, true);
    if (detailDistinta.error === false) {
      if (detailDistinta.CDIMA !== "")
        params.immagine = detailDistinta.CDIMA;
      else
        params.immagine = tavola;
      params.applicazione = carti;
      params.distintaGruppo = detailDistinta.DTTAV;
      params.distintaTavola = detailDistinta.DTAVO;
    }
    this.props.changeValues({ renewMutex: { mostraImg: false, modelli: false, tavole: true, distinta: true, applicazioni: true }, dataList: { applicazioni: [], immagineTavola: [], tavole: {}, distinta: {} }, filtersState: { telaio: "", applicazione: "", modello: "", tavola: "" } });
    this.props.setNewUrlState(params);
    this.props.handleClose();
    return true;
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
    clearTimeout(this.timeoutId);
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  initTimer = () => {
    this.timeoutId = setTimeout(this.blinkTooltip, 5000);
  };

  blinkTooltip = () => {
    if (!this.state.isHovered) {
      $('.tooltip_cart').fadeOut(() => {
        this.props.handleClose();
      })
    }
  }

  scrollToTarget = () => {
    if (this.targetRef.current) {
      const bodyHeight = document.getElementById("tooltip_cart_body").offsetHeight;
      const targetOffset = this.targetRef.current.offsetTop - document.getElementById("tooltip_cart_body").offsetTop - (bodyHeight / 2);
      this.targetRef.current.style.backgroundColor = '#e6e6e6';
      $('.tooltip_cart_body').animate({ scrollTop: targetOffset }, 'slow');
    }
  }

  removeAllArticoli(e) {
    e.persist()
    common.remove_localStorage("wishList");
    this.props.changeDatalist("wishList", []);
  }

  componentDidMount() {
    $('.tooltip_cart').fadeIn();
    if (this.state.arti) {
      this.scrollToTarget();
      this.initTimer();
    }
  }

  componentDidUpdate() {
    if (this.state.arti)
      this.blinkTooltip();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    const footerElem = document.getElementById('portal-top');
    const spanStyle = {
      textAlign: 'left',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: this.listVm.length > 0 ? '70%' : '100%',
    };

    let firstValid = true;
    let tot = 0, totRow = 0, totQta = 0;
    let valuta = "", out = "";
    let localeLang = common.getLanguageLocale();

    const wishlistItems = this.state.dataList.wishList.map((item, index) => {
      let target = false;
      totQta += parseInt(item.qpezzi);
      if (this.listVm.includes(item.marca)) {
        if (firstValid === true) {
          valuta = item.cvalu;
          firstValid = false;
        }
        tot += item.qpezzi * item.price;
        totRow = item.qpezzi * item.price;
        out = <span style={{ textAlign: 'right', width: '30%' }}>{totRow.toLocaleString(localeLang, { style: 'currency', currency: item.cvalu })}</span>
      }
      else if (this.listVm.length > 0) {
        out = <span style={{ textAlign: 'right', width: '25%' }}>N.D.</span>
      }
      if (this.state.arti) {
        if (this.state.arti.CARTI === item.carti || this.state.arti.CARTI === item.cartiSost)
          target = true;
      }

      return (
        <div key={index} ref={(ref) => target ? this.targetRef.current = ref : null} className='tooltip_cart_item'>
          <div className='row' style={{ justifyContent: 'space-between' }}>
            {item.marca && item.modello && item.tavola ?
              <Link to={"/draw/" + item.marca + "/" + item.modello + "/" + item.tavola} onClick={() => this.gotoTavola(item.marca, item.modello, item.tavola, item.carti)} style={spanStyle}><span>{item.darti}</span></Link>
              :
              <span style={spanStyle}>{item.darti}</span>
            }

            {out}
          </div>
          <div className='row' style={{ justifyContent: 'space-between' }}>
            {
              this.marcheVm.map((itemVm, indexVm) => (
                itemVm[0] === item.marca && (
                  <small key={indexVm}>{itemVm[1]}</small>
                )
              ))
            }
            <small>{common.getTrad("Pezzi") + ' '} {item.qpezzi}</small>
          </div>
        </div>
      )
    });

    if (!this.state.dataList.wishList || !this.state.dataList.wishList.length > 0)
      return null;

    if (this.state.showLoader)
      return (<LoaderView text={common.getTrad("Attendere, presto sarai reindirizzato")} url={this.checkout_data}></LoaderView>)

    return createPortal(
      <div className="tooltip_cart" onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <div className='tooltip_cart_header' style={{ textAlign: 'center' }}>
          <span>
            <strong>
              {
                this.state.arti ? (
                  <>
                    <i className='fas fa-check-circle justWished' />
                    {" " + common.getTrad('Aggiunto al carrello')}
                  </>
                ) : (
                  <>{" " + common.getTrad('Carrello')}</>
                )
              }
            </strong>
          </span>
        </div>
        <div className='tooltip_cart_body' id='tooltip_cart_body'>
          {wishlistItems}
        </div>
        <div className='tooltip_cart_footer'>
          <div className='row' style={{ justifyContent: 'space-between', paddingBottom: '10px' }}>
            {this.listVm.length > 0 && tot > 0 ? (
              <>
                <h6 style={{ textAlign: 'left' }}>{common.getTrad("Totale provvisorio")}</h6>
                <h6 style={{ textAlign: 'right' }}><strong>{tot.toLocaleString(localeLang, { style: 'currency', currency: valuta })}</strong></h6>
              </>
            ) : (
              <>
                <h6 style={{ textAlign: 'left' }}>{common.getTrad("Articoli")}: <strong>{totQta}</strong></h6>
              </>
            )}
          </div>
          {common.get_localStorage("checkout_url") && (
            <button className='btn bottone_default' onClick={(e) => { this.saveCheckout(e, this.state.dataList.wishList) }} style={{ width: '100%', margin: '8px 0' }}><i className="fas fa-shopping-basket"></i> {common.getTrad("Checkout")}</button>
          )}
          <button className='btn bottone_default' onClick={() => this.gotoCart()} style={{ width: '100%' }}>{common.getTrad("Vai al carrello")}</button>
        </div>
      </div>,
      footerElem
    );
  }
}

const mapStateToProps = state => {
  const store = wishListSelector(state);
  return { store };
}
export default connect(mapStateToProps, { changeDatalist, setNewUrlState, changeValues })(TooltipCart);